import { Component, inject } from '@angular/core';
import { ActivityReasonService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ActivityReasonCreateDto,
  ActivityReasonDto,
  ActivityReasonExcelDownloadDto,
  ActivityReasonUpdateDto,
} from '../proxy/controlling/dtos/activity-reason';
import { ACTIVITYREASON_CONFIG, ACTIVITYREASON_FIELDS } from './activity-reason.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-activity-reason',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ActivityReasonService, ConfirmationService],
  templateUrl: './activity-reason.html',
  styleUrl: './activity-reason.scss',
})
export class ActivityReason extends BaseCrudComponent<
  ActivityReasonDto,
  ActivityReasonCreateDto,
  ActivityReasonUpdateDto,
  ActivityReasonExcelDownloadDto
> {
  service = inject(ActivityReasonService);
  config = ACTIVITYREASON_CONFIG;
  fields = ACTIVITYREASON_FIELDS;

  protected prepareUpdateDto(data: any, selected: ActivityReasonDto): ActivityReasonUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ActivityReason';
  }
}
